import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "名前", -1)
const _hoisted_2 = { class: "text-left ml-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, "機材", -1)
const _hoisted_4 = { class: "text-left ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dbUser?.userName), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.dbUser?.description || '').split('\n'), (line, k) => {
        return (_openBlock(), _createElementBlock("div", { key: k }, _toDisplayString(line), 1))
      }), 128))
    ])
  ], 64))
}